<template>
	<div>
		<div>
			<div class="p-6">
				<div style="background: #FFFFFF; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3); border-radius: 5px;padding: 20px;">
					<div class="mb-5">
						<h4 class="uppercase font-bold block text-xl w-full">UPLOAD GIẤY CHUYỂN TIỀN</h4>
					</div>

					<div class="mb-5">
						<span class="text-warning text-sm break-normal" style="display: block; text-">(*) Tìm và chọn các lần thanh toán dưới đây để liên kết</span>
					</div>
					<div class="mb-5">
						<!-- <div class="mb-5">
							<label for class="text-base vs-input--label"> Nhà cung cấp: </label>
							<v-select
								:clearable="false"
								class="border-none w-full"
								:placeholder="`Chọn nhà cung cấp`"
								v-model="supplier"
								name="supplier"
								:options="$store.state.moduleProduct.suppliers"
								:reduce="(p) => p.id"
								label="name"
								:data-vv-as="'Nhà cung cấp'"
							/>
						</div>
						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Số hóa đơn
							</label>
							<cbs-input type="text" inputmode="text" v-model="payno_text" class="w-full" name="payno_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div> -->

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Từ ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="date" placeholder="Chọn thời gian vận đơn" :picker-options="pickerOptions" />
						</div>

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Tới ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="date" placeholder="Chọn thời gian vận đơn" :picker-options="pickerOptions" />
						</div>

						<!-- <div class="mb-5">
							<label for class="text-base vs-input--label">
								Tên file UNC
							</label>
							<cbs-input type="text" inputmode="text" v-model="unc_text" class="w-full" name="unc_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div> -->

						<div class="flex justify-end mb-5" slot="footer" vs-justify="end">
							<vs-button class="vs-component vs-button font-bold" @click.stop="applySeeking()">Tìm</vs-button>
						</div>

						<label for class="text-base vs-input--label mb-5" style="display: block;" v-show="totalPaynos > 0">Tổng cộng đã chọn: {{$helper.numFormat(totalPaynos)}}</label>
						
						<vs-row class="mb-5" :key="indextr" v-for="(itemPayment, indextr) in thanhtoans">
							<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
								<vs-checkbox :disabled="!isEditablePayno" :name="'payment_'+indextr" v-model="payment_files[itemPayment.id]" color="primary" :id="'payment_'+indextr" :vs-value="itemPayment.id.toString()" />
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{itemPayment.payment_no}}
								</label>
							</vs-col>
							<vs-col vs-w="3" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.momentFormat(itemPayment.payment_date)}}
								</label>
							</vs-col>
							<vs-col vs-w="3" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.numFormat(itemPayment.payment_value)}}
								</label>
							</vs-col>
						</vs-row>

						<div class="mb-5 mt-5" style="align-items: center; align-items: center;display: flex;flex-direction: row;width: 100%;">
							<div v-if="isEditablePayno" @click="uploadChungTu()" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: '#FFFFFF', color: '#057FBB', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}">
								<svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.75 23C6.13125 23 5.60175 22.7799 5.1615 22.3396C4.7205 21.8986 4.5 21.3687 4.5 20.75V17.375H6.75V20.75H20.25V17.375H22.5V20.75C22.5 21.3687 22.2799 21.8986 21.8396 22.3396C21.3986 22.7799 20.8687 23 20.25 23H6.75ZM12.375 18.5V9.33125L9.45 12.2562L7.875 10.625L13.5 5L19.125 10.625L17.55 12.2562L14.625 9.33125V18.5H12.375Z" fill="#057FBB"/>
								</svg>
								Upload giấy chuyển tiền
							</div>
							<div class="ml-3" @click="setPaymentInfo()" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: (files && files.length >= 1 ? '#057FBB' : '#D4D4D4'), color: '#FFFFFF', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}" >
								<svg class="mr-1" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13.5 17.5219C13.35 17.5219 13.2094 17.4983 13.0781 17.451C12.9469 17.4045 12.825 17.325 12.7125 17.2125L8.6625 13.1625C8.45625 12.9563 8.35313 12.6938 8.35313 12.375C8.35313 12.0563 8.45625 11.7938 8.6625 11.5875C8.86875 11.3813 9.13575 11.2733 9.4635 11.2635C9.792 11.2545 10.0594 11.3531 10.2656 11.5594L12.375 13.6687V5.625C12.375 5.30625 12.483 5.03888 12.699 4.82288C12.9143 4.60763 13.1812 4.5 13.5 4.5C13.8188 4.5 14.0861 4.60763 14.3021 4.82288C14.5174 5.03888 14.625 5.30625 14.625 5.625V13.6687L16.7344 11.5594C16.9406 11.3531 17.208 11.2545 17.5365 11.2635C17.8643 11.2733 18.1312 11.3813 18.3375 11.5875C18.5437 11.7938 18.6469 12.0563 18.6469 12.375C18.6469 12.6938 18.5437 12.9563 18.3375 13.1625L14.2875 17.2125C14.175 17.325 14.0531 17.4045 13.9219 17.451C13.7906 17.4983 13.65 17.5219 13.5 17.5219ZM6.75 22.5C6.13125 22.5 5.60175 22.2799 5.1615 21.8396C4.7205 21.3986 4.5 20.8687 4.5 20.25V18C4.5 17.6812 4.60763 17.4139 4.82288 17.1979C5.03888 16.9826 5.30625 16.875 5.625 16.875C5.94375 16.875 6.21112 16.9826 6.42712 17.1979C6.64237 17.4139 6.75 17.6812 6.75 18V20.25H20.25V18C20.25 17.6812 20.358 17.4139 20.574 17.1979C20.7892 16.9826 21.0562 16.875 21.375 16.875C21.6938 16.875 21.9608 16.9826 22.176 17.1979C22.392 17.4139 22.5 17.6812 22.5 18V20.25C22.5 20.8687 22.2799 21.3986 21.8396 21.8396C21.3986 22.2799 20.8687 22.5 20.25 22.5H6.75Z" fill="white"/>
								</svg>
								Lưu lại
							</div>
						</div>
						<div id="custom-upload">
							<CbsUploadRefCustom
								value="value"
								:key="timeKey2"
								:isEditable="isEditablePayno"
								v-model="localAttachFile"
								accept="*"
								:limit="10"
								:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
								:dataValue="shippingHackPayments"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";

export default {
	name: "AccountUncHistoryBB",
	components: { vSelect, SelectAssigned, CbsUploadRefCustom, ListUploadMode },
	props: {
		// isPopupActive: {
		// 	type: Boolean,
		// 	required: true,
		// },
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			thanhtoans: [],
			uncHoaDon: {},
			uncHoaDonMap: {},
			unc_text: '',
			from_date: '',
			to_date: '',
			pickerOptions: {},
			payno_checked: null,
			supplier: '',
			payno_text: '',
			totalPaynos: 0,
			shippingHackPayments: [],
			data2: {},
			payment_files: [],
			payment_nos: [],
			activeShipping: {},
			shippingActiveIndex: 0,
			data2: {},
			cus_name: null,
			supplier_name: null,
			status: 0,
			productName: null,
			timeKey: Date.now(),
			timeKey2: Date.now(),
			photos: [],
			files: [],
			value: {},
			product: null,
			quantity: null,
			price: null,
			address: null,
			note: null,
			accountant_note: null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			id: 0,
			product_id: 0,
			isEditablePayno: true,
			listShippingsByPmid: [],
			listShippingsByPmidStr: '',
			sohoadonstr: ''
		};
	},
	watch: {
		payment_files: {
			handler(val) {
				console.log('payment_files: ', val);
				let maps = {};
				for (let kk in this.thanhtoans) {
					let itemTmp = this.thanhtoans[kk];
					if (itemTmp) {
						maps[itemTmp.id] = itemTmp;
					}
				}
				let total = 0;
				if (Object.keys(maps).length) {
					for (let k in val) {
						let kk = val[k];
						if (kk && maps.hasOwnProperty(kk)) {
							total += parseInt(maps[kk].payment_value);
						}
					}
				}
				this.totalPaynos = total;
			},
			deep: true
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('localAttachFile this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('localAttachFile set.value: ' , val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				console.log('this.files: ', this.files);
				// this.setPaymentInfo();
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
	},
	methods: {
		changeItem(item) {
			console.log(item);
			// this.shippingHackPayments = item.uncs || [];
			this.payment_nos = item.hoadons;
		},
		applySeeking() {
			if (this.supplier == null) {
				this.$helper.notifyWarning({ context: this, options: {
					text: 'Hãy chọn NCC',
				}});
				return;
			}
			this.getPaymentNos();
		},
		uploadChungTu() {
			document.querySelector('#custom-upload .el-upload__input').click();
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getPaymentNos() {
			this.$vs.loading();
			try {
				let payload = {id: this.supplier ? this.supplier : 0, payno_text: this.payno_text, unc_text: this.unc_text, from_date: this.from_date, to_date: this.to_date, type: 'thuysan'};
				this.$store.dispatch("moduleProduct/getPaymentNos", payload).then(response => {
					console.log('getPaymentNos: ', response);
					
					let thanhtoans = [];
					for (let k in response) {
						let hoadon = response[k];
						if (hoadon.thanhtoans) {
							for (let kk in hoadon.thanhtoans) {
								let uncTmp = hoadon.thanhtoans[kk];
								if (uncTmp) {
									if (!uncTmp.payment_method || uncTmp.payment_method != 2) {
										uncTmp.id = `${hoadon.id}_${uncTmp.payment_date}_${kk}`;
										uncTmp.payment_no = hoadon.matching ? hoadon.matching.cus_name : 'NA';
										if (!uncTmp.payment_files || uncTmp.payment_files.length < 1) {
											thanhtoans.push(uncTmp);
										}
									}
								}
							}
						}
					}
					this.thanhtoans = thanhtoans;


					this.$vs.loading.close();
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setPaymentInfo() {
			console.log(this.payment_files);
			let files = [];
			for (let k in this.payment_files) {
				let file = this.payment_files[k];
				if (file) {
					files.push(k);
				}
			}
			console.log('files: ', files);
			
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.$t("Actions.Confirm"),
				text: 'Xác nhận lưu giấy chuyển tiền này',
				// accept: () => this.deleteCustomer(customer._id),
				accept: async () => {
					try {
						// this.$vs.loading();
						let payload = {id: this.supplier ? this.supplier : 0, checked_ids: files, type: 'new', files: this.files};
						console.log(payload);
						await this.$store.dispatch("moduleProduct/setPaymentInfoAqua", payload);
						this.$helper.notifySuccess({ context: this, options: {
							text: 'Đã lưu',
						}, });
						this.applySeeking();
						this.payment_nos = [];
					} catch (error) {
						console.log('error: ', error);
						this.$helper.notifyWarning({ context: this, options: {
							text: error,
						}, });
					} finally {
						this.$vs.loading.close();
					}
				},
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
	created() {
		// console.log('created: ', Date.now());
		// this.getOrder(true);
	}
};
</script>

<style>
#custom-upload-history .el-upload--picture-card {
	display: none;
}
</style>